import { resetPunteggio, addButton, addBackground, setupSceneScale } from "./utility.js";

export default function inizio(k) {
    k.scene("inizio", () => {
        setupSceneScale();
        addBackground();
        k.play("ginu", {
            loop: true,
            volume: 0.5
        });
        k.add([
            color(255, 0, 127),
            text("PANDA CRASH ROYAL", {
                size: 64, 
                outline: { 
                    size: 20, 
                    color: rgb(0, 255, 0)
                }
            }),
            anchor("center"),
            pos(width() / 2, 50),
        ])
        k.loadSprite("logo", "./sprites/pando.png");
        k.add([
            sprite("logo"),
            anchor("center"),
            pos(width() / 2, 300),
            scale(3),
            rotate(0),
            animate({ relative: true }),
            "logo",
        ]);
        
        // Adds the buttons with the function we added
        addButton("Inizia il gioco", vec2(width() / 2, height() - 220), () => {
            resetPunteggio();
            go("primoLivello");
        });

        addButton("Classifica", vec2(width() / 2, height() - 120), () => {
            go("classifica");
        });

             k.add([
            text("creato per Matilde"),
            anchor("center"),
            pos(width() / 2, height() - 40),
        ])

        // Animate properties easily thanks to animate() comp
        const logo = k.get("logo")[0];
        logo.animate("pos", [vec2(0, -50), vec2(0), vec2(0, -50)], {
            duration: 5,
            easing: easings.easeInOutQuad,
        });
        logo.animate("scale", [vec2(1), vec2(1.1), vec2(1)], {
            duration: 2.5,
            easing: easings.easeInOutQuad,
        });
        logo.animate("angle", [2, -2], {
            duration: 1.25,
            direction: "ping-pong",
            easing: easings.easeInOutQuad,
        });
        logo.animation.seek(2.5);
    });
}